export default __webpack_public_path__ + "static/media/saudiFlag.ad607301.png";